// Single owner of "stored order_items row -> running-order form line".
//
// backend/utils/ongoingOrders.js (loadOrderItemsForRecalc) maps persisted rows the
// same way, and the two MUST agree: the pricing engine recomputes
// unit_price_final = unit_price x (1 - discount_percent/100), so the input
// unit_price has to be the agreed base (unit_price_before_discount). Handing it
// unit_price_final instead re-applies the manual discount a second time, and the
// wizard then shows a subtotal and total below the ones the server stored.
const DEFAULT_VAT_RATE = 8.1;

// One stored line, ready for computeAdminOrderTotals. `localId` is injected so the
// caller owns key generation; everything else is derived, never hand-copied.
export function runningOrderLine(row, localId) {
  const finalUnit = Number(row.unit_price_final) || 0;
  const baseUnit = row.unit_price_before_discount != null
    ? Number(row.unit_price_before_discount) || 0
    : finalUnit;

  return {
    localId,
    type: row.variant_id ? 'product' : 'adhoc',
    variant_id: row.variant_id || '',
    name: row.name || '',
    sku: row.product_sku || row.sku || '',
    // Credits are negative-quantity lines: keep the sign, never coerce to a minimum.
    quantity: Number(row.quantity) || 0,
    unit: row.unit || 'pcs',
    unit_price: baseUnit,
    vat_rate: Number(row.vat_rate ?? DEFAULT_VAT_RATE),
    discount_percent: Math.min(100, Math.max(0, Number(row.discount_percent) || 0)),
    priceAuto: false,
    // Identity + shipped progress: both are lost if they are not carried across, which
    // silently reopens duplicate/overwrite and unlocked-fulfilment-line bugs.
    order_item_id: row.id || undefined,
    total_shipped: Number(row.total_shipped || 0),
  };
}

export function runningOrderLines(rows, keyFor) {
  return (rows || []).map((row, idx) => runningOrderLine(row, keyFor(row, idx)));
}